import React, { useState, useEffect, useMemo } from 'react';
import { getLocation, getLocationDetails } from '../../../../../redux/location/locationAction';
import { useDispatch, useSelector } from 'react-redux';
import InputField from '../../../../common/InputField';
import SelectOption from '../../../../common/SelectOption';
import AutoCompleteField from '../../../../common/AutoCompleteField';
import RadioButton from '../../../../common/RadioButton';
import CheckboxGroup from '../../../../common/CheckboxGroup';
import {
  IMAGE_CLOUD_NAME,
  IMAGE_CLOUD_PRESET,
  IMAGE_CLOUD_FOLDER,
  IMAGE_CLOUD_PATH,
} from '../../../../../settings';
import { Popconfirm, Row, Col } from 'antd';
import {
  deleteImage,
  getAmenities,
  getApplicableTaxes,
  getPackageTypes,
  getSpaceCategoryDetails,
  getSpaceEventTypes,
  getRules,
} from '../../SpaceAction';
import CommonCheckBox from '../../../../common/CommonCheckBox';
import Activity from './Activity';
import { saveActivities } from '../../../../../redux/Activity/activityAction';
import { Form } from 'antd';
import {
  postalAddressValidation,
  spaceCityValidation,
  spaceDescriptionValidation,
  spaceNameValidation,
  spaceOrgNameValidation,
  spaceUniqueIdValidation,
  taxRegValidation,
  validationNoticePeriod,
  postalCodeValidation,
} from '../../../../../helper/FeildValidations';
import InputNumberField from '../../../../common/InputNumberField';
import SpaceLocation from '../SpaceLocation/SpaceLocation';
import { BOOKING_TYPE, COUNTRY_CODES } from '../../../../common/constants';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import RichTextEditor from '../../../../common/RichTextEditor';
import { space } from '../../../../../api/apiPaths'; // ES6
import { setDescriptionError } from '../../../../../redux/actions/uistate';

const BasicDetails = ({
  handleCategoryChange,
  form,
  handleActivityChange,
  handleCurrencyChange,
  setSpaceImages,
  spaceImages,
  category,
  countryFiltering,
  countryCodeSelection,
  setCategory,
  venueTypes,
  setVenueTypes,
  images,
  isEdit,
  showDescriptionError,
}) => {
  const dispatch = useDispatch();
  const formFields = form.getFieldValue();
  const spaceActivities = useSelector((state) => state.space?.spaceCategory?.data || []);
  const applicableTaxes = useSelector((state) => state.space?.taxes?.data || []);
  const locations = useSelector((state) => state.location?.places?.data || []);
  const spaceDetails = useSelector((state) => state.space?.spaceDetails?.data || []);

  const countryBaseLocation = useSelector(
    (state) => state.space?.spaceDetails?.data?.location?.country || []
  );
  const platforms = useSelector((state) => state.space?.platformData?.data || []);
  const spaceCategory = useSelector((state) => state.space?.spaceCategory?.data || []);
  const [country, setCountry] = useState(null);
  const [workActivityId, setWorkActivityId] = useState();
  const [meetTrainActivityIds, setMeetTrainActivityIds] = useState([]);
  const [activity, setActivity] = useState([]);
  const [primarySpaceImage, setPrimarySpaceImage] = useState(
    isEdit && formFields?.image ? formFields.image.find((i) => i.isPrimary == true) : {}
  );


const [spaceVideo, setSpaceVideo] = useState(
  isEdit && formFields?.video ? formFields.video : null
);

  const [isTaxRegister, setTaxRegisterStatus] = useState(false);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [description, setDescription] = useState('');
  const [enableCategory, setEnableCategory] = useState(true)
  const descriptionError = useSelector((state) => state.uiState.descriptionError);

  // useEffect(() => {
  //   console.log('spaceImages', spaceImages);
  // }, []);

  useEffect(() => {
    setMeetTrainActivityIds([]);
  }, [category]);

  useEffect(() => {
    dispatch(getSpaceCategoryDetails(country));
    dispatch(getRules(country));
    dispatch(getPackageTypes(country));
    dispatch(getAmenities(country));

    const category = form.getFieldValue('category');
    if (category?.length > 0 || isEdit) {
      form.setFieldsValue({
        eventId: [],
        events: spaceDetails?.events?.map((event) => {
          return {
            amenities: event.amenities ?  event.amenities[null] : event.amenities ,
          };
        }),
      });
    }
  }, [country]);

  useEffect(() => {
    if (isEdit) {
      setSelectedSystem(formFields.platform);
      setTaxRegisterStatus(formFields.notTaxRegistered);
      setPrimarySpaceImage(spaceImages.find((i) => i.isPrimary == true) || {});
      dispatch(getLocation(formFields.location?.address || null));
      setMeetTrainActivityIds(formFields.eventTypes);
    }
  }, [formFields.id]);
  useEffect(() => {
    if (isEdit && locations.length > 0) {
      const { place_id } = locations.find((i) => i.description);
      dispatch(getLocationDetails(place_id));
    }
  }, [locations]);

  useEffect(() => {
    setPrimarySpaceImage(spaceImages.find((i) => i.isPrimary == true) || {});
  }, [spaceImages]);

  form.getFieldValue();

  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];

  const handleOnchange = (value) => {
    if (value && value.length > 5) {
      dispatch(getLocation(value));
    }
  };

  const handleCategoryOnSelect = (id) => {
    setActivity([]);
    handleCategoryChange(id);
  };

  const handleCountrySelect = (country) => {
    setEnableCategory(false)
    countryFiltering(country);
   // const currency = country === 'SG' ? 'SGD' : 'LKR';
    const currency = getCurrencyByCountry(country) ;
    form.setFieldsValue({
      spaceCurrency: currency,
      applicableTaxes: undefined,
    });
    handleCurrencyChange(currency);
    setCountry(country);
    dispatch(getApplicableTaxes(country));
    setGeoLocationForSelectedCountry(country);
  };

  const getCurrencyByCountry = (country)=>{
    switch (country) {
      case 'LK':return 'LKR'
      break;
      case 'SG':return 'SGD'
      break;
      case 'AUS':return 'AUD'
      break;
    
      default: return 'N/A'
        break;
    }
  }

  const setGeoLocationForSelectedCountry = (country) => {
    const location = form.getFieldValue('location');
    const selectedLocation = COUNTRY_CODES.find((countryList) => country === countryList.name);
    form.setFieldsValue({
      location: {
        ...location,
        geoLocation: { longitude: selectedLocation.lng, latitude: selectedLocation.lat },
      },
    });
  };

  const handleActivityOnSelect = (activityId) => {
    if (category !== 'Work') {
      handleActivityChange(category, [...meetTrainActivityIds, activityId]);
      setMeetTrainActivityIds([...meetTrainActivityIds, activityId]);
      dispatch(saveActivities([...meetTrainActivityIds, activityId]));
    } else {
      const { name } = venueTypes.find((i) => i.id === activityId);
      setActivity(name);
      handleActivityChange(category, activityId);
      setWorkActivityId(activityId);
    }
  };

  const deselectItems = (id) => {
    const filteredMeetTrain = meetTrainActivityIds.filter((i) => i !== id);
    handleActivityChange(category, filteredMeetTrain);
    setMeetTrainActivityIds(filteredMeetTrain);
    dispatch(saveActivities(filteredMeetTrain));
  };

  const deleteImageFromCloud = (isPrimary, etag) => {
    dispatch(deleteImage(etag));
    if (isPrimary) {
      setSpaceImages(spaceImages.filter((i) => i.etag !== etag));
    } else {
      setPrimarySpaceImage({});
      setSpaceImages(spaceImages.filter((i) => i.etag !== etag));
    }
  };

  const deleteVideoFromCloud = (etag) => {
  dispatch(deleteImage(etag));
  
  setSpaceImages(spaceImages.filter(item => item.etag !== etag));
  
  setSpaceVideo(null);
};
  useEffect(() => {}, [spaceImages]);

  const openWidget = (isPrimary) => {
    window.cloudinary.openUploadWidget(
      {
        cloud_name: IMAGE_CLOUD_NAME,
        upload_preset: IMAGE_CLOUD_PRESET,
        theme: 'white',
        folder: IMAGE_CLOUD_FOLDER,
        client_allowed_formats: ['png', 'jpeg', 'pdf'],
        sources: ['local'],
        multiple: false,
        resource_type: 'image',
        name: 'image',
        // thumbnailTransformation: [{ width: 100, height: 100, crop: 'fit' }][
        //   ({ width: 200, height: 200, crop: 'fill' }, { effect: 'sepia' })
        // ]
      },
      (error, result) => {
        // If no errors then save image data in ms dbs.
        if (!error && result && result.event === 'success') {
          const originalFilename = result.info.original_filename || result.info.name || 'image';
          const imageName = `image`;
          setSpaceImages([
            ...spaceImages,
            {
              url: result.info.public_id,
              publicId: result.info.public_id,
              deleteToken: result.info.delete_token,
              etag: result.info.etag,
              signature: result.info.signature,
              isPrimary: isPrimary,
              resource_type: result.info.resource_type,
              name: imageName,
            },
          ]);

          if (isPrimary) {
            setPrimarySpaceImage({
              url: result.info.public_id,
              publicId: result.info.public_id,
              deleteToken: result.info.delete_token,
              etag: result.info.etag,
              signature: result.info.signature,
              isPrimary: isPrimary,
              name: imageName,
            });
          }
          console.log('cloudinary result', result);
        }
      }
    );
  };

  const openVideoWidget = () => {
    window.cloudinary.openUploadWidget(
      {
        cloud_name: IMAGE_CLOUD_NAME,
        upload_preset: IMAGE_CLOUD_PRESET,
        theme: 'white',
        folder: IMAGE_CLOUD_FOLDER,
        client_allowed_formats: ['mp4', 'webm', 'mov'],
        sources: ['local'],
        multiple: false,
        resource_type: 'video',
        name: 'video',
        max_file_size: 104857600, 
      },
      (error, result) => {
        if (!error && result && result.event === 'success') {
          const originalFilename = result.info.original_filename || result.info.name || 'video';
          const videoName = `video`;

          const videoData = {
          url: result.info.public_id,
          publicId: result.info.public_id,
          deleteToken: result.info.delete_token,
          etag: result.info.etag,
          signature: result.info.signature,
          isPrimary: false,
          name: videoName,
          isVideo: true,
          resource_type: result.info.resource_type,
          format: result.info.format || 'mp4',
          // format: result.info.format,
          // duration: result.info.duration,
          // path: result.info.path
        };
        
        setSpaceImages([...spaceImages, videoData]);
        
        setSpaceVideo(videoData);
        
        }
      }
    );
  };

  const handleTaxRegisterOnChange = (e) => {
    setTaxRegisterStatus(e.target.checked);
  };
  const handleAddressOnSelect = (value) => {
    const { place_id } = locations.find((i) => i.description);
    dispatch(getLocationDetails(place_id));
  };

  const handleDescription = (content, delta, source, editor) => {
    const txtLength = editor?.getText()?.trim()?.length || 0;
    if (txtLength < 3 || txtLength >= 5000) {
      dispatch(setDescriptionError(true))
    } else {
      dispatch(setDescriptionError(false));
    }
    setDescription(content);
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', { color: [] }],
      [{ size: [] }],
    ],
  };
  const formats = ['bold', 'italic', 'underline', 'list', 'bullet', 'link', 'color', 'size'];

  return (
    <div className="basic-details-wrapper">
      <h3>Space details </h3>
      <Form.Item name={'spaceStatus'}> </Form.Item>
      <InputField name={'spaceName'} label={'Space Title'} rules={spaceNameValidation} />
      <InputField
        name={'organizationName'}
        label={'Organization Name'}
        rules={spaceOrgNameValidation}
      />
      <RichTextEditor
        theme={'snow'}
        name={'description'}
        label={'Description'}
        valueName={description}
        handleOnChange={handleDescription}
        modules={modules}
        formats={formats}
        // rules={spaceDescriptionValidation}
      />

      {/* temp styling  */}
      {descriptionError && (
        <div role="alert" class="ant-form-item-explain-error" style={{ marginRight: '-50px', marginTop:'-20px', marginBottom:'20px'  }}>
          Minimum Character Limit 3 or Reach Maximum Character Limit
        </div>
      )}

      {/* <SelectOption
          isMultiple={false}
          name={'instanceBookingAvailability'}
          placeholder={'Select Booking Type'}
          rules={[
            {
              required: true
            }
          ]}
          label={'Booking Type'}
          values={BOOKING_TYPE}
          labelName={'name'}
          valueName={'boolValue'}
      /> */}
      <SelectOption
        isMultiple={false}
        name={['platform']}
        placeholder={'System'}
        rules={[
          {
            required: true,
          },
        ]}
        label={'System'}
        values={
          platforms
            ? platforms.map((p) => {
                return { label: p.description, name: p.code };
              })
            : []
        }
        handleOnSelect={(e) => setSelectedSystem(e)}
        labelName={'label'}
        valueName={'name'}
      />
      {selectedSystem !== 'SYSTEM' && (
        <InputField
          name={'platformReference'}
          label={'Unique Id'}
          rules={spaceUniqueIdValidation}
        />
      )}
      <InputField name={['location', 'city']} label={'City'} rules={spaceCityValidation} />

      <SelectOption
        isMultiple={false}
        name={['location', 'country']}
        placeholder={'Select country'}
        rules={[
          {
            required: true,
          },
        ]}
        label={'Countries'}
        values={COUNTRY_CODES}
        handleOnSelect={handleCountrySelect}
        labelName={'label'}
        valueName={'name'}
      />

      {(isEdit && countryBaseLocation === 'AUS') || (isEdit === false && country === 'AUS') ? (
        ''
      ) : (
        <>
          <AutoCompleteField
            label={'Street Name'}
            name={['location', 'address']}
            valueName={'description'}
            labelName={'description'}
            rules={rules}
            options={locations}
            handleOnChange={handleOnchange}
            handleOnSelect={handleAddressOnSelect}
          />
          <InputField
            name={['location', 'postalCode']}
            label={'Postal Code'}
            rules={postalCodeValidation}
          />
          <InputField
            name={['location', 'postalAddress']}
            label={'Postal Address'}
            rules={postalAddressValidation}
            isDisabled={false}
          />
        </>
      )}

      <SpaceLocation form={form} />

      <SelectOption
        isMultiple={false}
        name={['category']}
        placeholder={'Category'}
        rules={rules}
        label={'Category'}
        values={spaceActivities}
        labelName={'name'}
        valueName={'id'}
        handleOnSelect={handleCategoryOnSelect}
        disabled={enableCategory}
      />

      <Activity
        handleActivityOnSelect={handleActivityOnSelect}
        category={category}
        venueTypes={venueTypes}
        deselectItems={deselectItems}
        disabled={isEdit}
      />
      {/* {country === 'SG' && (
        <RadioButton
          name={'instantOrRequest'}
          label={'Booking Type'}
          list={[
            { value: 'instantBooking', label: 'Instant booking' },
            { value: 'requestToBook', label: 'Request to book' }
          ]}
          labelName={'label'}
          valueName={'value'}
        />
      )} */}
      {country === 'SL' && (activity === 'Private Office' || activity === 'Booth') && (
        <CheckboxGroup
          name={'isViewAppointments'}
          label={'View Appointments'}
          labelName={'label'}
          valueName={'value'}
          list={[{ value: 'isViewAppointments', label: 'View Appointments' }]}
        />
      )}
      <Row>
        <Col offset={8}></Col>
        <Col className="click-me-wrapper" span={16}>
        <div>
          <h4>Space Images</h4>
          {Object.values(primarySpaceImage).length ? (
            <Popconfirm
              title="Are you sure delete this image?"
              onConfirm={(e) => deleteImageFromCloud(true, primarySpaceImage.etag)}
              okText="Yes"
              cancelText="No"
            >
              <div
                className="img-block-wrapper"
                style={{ backgroundImage: `url(${IMAGE_CLOUD_PATH}${primarySpaceImage.url}.jpeg)` }}
              ></div>
            </Popconfirm>
          ) : (
            <></>
          )}

          {!Object.values(primarySpaceImage).length && (
            <div onClick={(e) => openWidget(true)} className="img-block primary-img add-media-btn">
              <div className="img-block-inner-wrapper">
                <span>Add primary image</span>
              </div>
            </div>
          )}

          <div className="image-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '10px' }}>
          {spaceImages
            .filter((image) => image.isPrimary === false && (!image.name || image.name !== 'video'))
            .map((image) => {
              return (
                <Popconfirm
                  title="Are you sure delete this image?"
                  onConfirm={(e) => deleteImageFromCloud(false, image.etag)}
                  okText="Yes"
                  cancelText="No"
                >
                  <div
                    className="img-block-wrapper"
                    style={{ backgroundImage: `url(${IMAGE_CLOUD_PATH}${image.url}.jpeg)` }}
                  ></div>
                </Popconfirm>
              );
            })}
            <div onClick={(e) => openWidget(false)} className="img-block secondary-img add-media-btn">
            <div className="img-block-inner-wrapper">
              <span>Add Image</span>
            </div>
          </div>
          </div>
          </div>
        
          <div className="media-section-container" style={{ marginTop: '20px' }}>
              <h4>Space Videos</h4>
              {spaceImages
              .filter((image) => image.isPrimary === false && (image.name && image.name === 'video'))
              .map((image) => {
                return (
                  <Popconfirm
                    key={image.etag}
                    title="Are you sure delete this video?"
                    onConfirm={(e) => deleteImageFromCloud(false, image.etag)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div
                      className="img-block-wrapper"
                      style={{ backgroundImage: `url(${IMAGE_CLOUD_PATH}/video/upload/${image.url}.jpeg)` }}
                    ></div>
                  </Popconfirm>
                );
              })}
            </div>
          
        </Col>
      </Row>

      {/* add video */}
      <Row>
        <Col offset={8}></Col>
        <Col className="click-me-wrapper" span={16}>
          {/* {spaceVideo ? (
            <Popconfirm
              title="Are you sure you want to delete this video?"
              onConfirm={() => deleteVideoFromCloud(spaceVideo.etag)}
              okText="Yes"
              cancelText="No"
            >
              <div className="video-container">
                <video 
                  controls 
                  width="100%" 
                  // style={{ backgroundImage: `url($${IMAGE_CLOUD_PATH}video/upload/${spaceVideo.url}` }}

                  // src={`${IMAGE_CLOUD_PATH}video/upload/${spaceVideo.url}`}
                />
                <div className="video-overlay">Click to remove</div>
              </div>
            </Popconfirm>
          ) : ( */}
            <div onClick={openVideoWidget} className="video-upload-block">
              <div className="video-upload-inner">
                <span>Upload space video</span>
                <small>Supported formats: MP4, WebM, MOV (max 100MB)</small>
              </div>
            </div>
          {/* )} */}
        </Col>
      </Row>
      
      <InputField name={'spaceCurrency'} label={'Space Currency'} rules={rules} isDisabled={true} />

      {(countryBaseLocation === 'LK' || country === 'LK') ||  (countryBaseLocation === 'SG'|| country === 'SG') ? (
        <Row>
          <Col offset={8}></Col>
          <Col span={16} className="chk-bx">
            <CommonCheckBox
              name={'notTaxRegistered'}
              label={'Not Tax Registered'}
              handleOnChange={handleTaxRegisterOnChange}
            />
          </Col>
        </Row>
      ) : (
        <></>
      )}

    

{((countryBaseLocation === 'LK' || country === 'LK') ||  (countryBaseLocation === 'SG'|| country === 'SG')) && !isTaxRegister ? (
        <div>
          <InputField
            name={'taxRegNo'}
            label={'Tax Registration Number'}
            rules={taxRegValidation}
            isDisabled={false}
          />
          <SelectOption
            isMultiple={true}
            name={'applicableTaxes'}
            placeholder={'Applicable Taxes'}
            rules={rules}
            label={'Applicable Taxes'}
            values={applicableTaxes}
            labelName={'taxName'}
            valueName={'id'}
            handleOnSelect={null}
          />
        </div>
      ) : (
        <></>
      )}
    
      <InputNumberField
        name={'noticePeriod'}
        label={'Notice Period'}
        rules={validationNoticePeriod}
        minAmount={0}
        maxAmount={999}
      />
    </div>
  );
};

export default BasicDetails;
